import React from 'react';
import { Activity, Award, BarChart3, Brain, Heart, Mail, Shield, TrendingUp, Trophy, Users, Zap } from 'lucide-react';
import { StatCard } from '../SharedComponents';

const BadgesTab = ({ ctx }) => {
  const { members, badgesData } = ctx;

  return (
<div data-testid="badges-tab">
  <h1 className="text-xl font-bold mb-1" style={{ color: '#1A1209' }}>Skills Certification Badges</h1>
  <p className="text-xs mb-5" style={{ color: '#999' }}>
    Track which skills certifications your team members have earned. Badges are awarded automatically when thresholds are met.
  </p>

  {badgesData?.demo_data && (
    <div className="flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-medium mb-4" style={{ backgroundColor: '#EFF6FF', color: '#1E40AF', border: '1px solid #BFDBFE' }}>
      <BarChart3 size={14} />
      Sample data — showing what badges will look like with active team members
    </div>
  )}

  {/* Summary stats */}
  {badgesData && (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-5">
      <StatCard label="Total Badges Earned" value={badgesData.total_earned} icon={<Award size={16} style={{ color: '#F5831F' }} />} />
      <StatCard label="Badge Types" value={badgesData.badges?.length || 0} icon={<Shield size={16} style={{ color: '#8B5CF6' }} />} />
      <StatCard label="Team Members" value={badgesData.total_members} icon={<Users size={16} style={{ color: '#2563EB' }} />} />
    </div>
  )}

  {/* Badge grid */}
  {badgesData?.badges?.length > 0 ? (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {badgesData.badges.map(b => {
        const iconMap = { shield: Shield, heart: Heart, ear: Activity, handshake: Users, mic: Zap, users: Users, 'message-square': Mail, flame: TrendingUp, trophy: Trophy, brain: Brain };
        const BadgeIcon = iconMap[b.icon] || Award;
        const pct = b.earn_rate;
        return (
          <div key={b.badge_id} className="bg-white rounded-xl p-5 transition-all hover:shadow-md" style={{ border: '1px solid #E8E8E8' }} data-testid={`badge-${b.badge_id}`}>
            <div className="flex items-start gap-3 mb-3">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${b.color}15` }}>
                <BadgeIcon size={22} style={{ color: b.color }} />
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-bold" style={{ color: '#1A1209' }}>{b.name}</h4>
                <p className="text-[10px] mt-0.5" style={{ color: '#999' }}>{b.description}</p>
              </div>
            </div>
            <div className="flex items-center justify-between mb-2">
              <span className="text-[10px] font-semibold" style={{ color: '#666' }}>{b.earned_count} / {b.total_members} earned</span>
              <span className="text-sm font-black" style={{ color: b.color }}>{pct}%</span>
            </div>
            <div className="w-full h-2 rounded-full" style={{ backgroundColor: '#F0F0F0' }}>
              <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, backgroundColor: b.color }} />
            </div>
            <div className="flex items-center gap-2 mt-2">
              <span className="px-2 py-0.5 rounded-full text-[9px] font-bold" style={{ backgroundColor: `${b.color}15`, color: b.color }}>{b.category}</span>
              <span className="text-[9px]" style={{ color: '#CCC' }}>Threshold: {b.threshold}</span>
            </div>
          </div>
        );
      })}
    </div>
  ) : (
    <div className="bg-white rounded-xl p-8 text-center" style={{ border: '1px solid #E8E8E8' }}>
      <Award size={32} style={{ color: '#DDD' }} className="mx-auto mb-3" />
      <p className="text-sm" style={{ color: '#999' }}>Badge data will appear once team members start earning certifications.</p>
    </div>
  )}
</div>
  );
};

export default BadgesTab;
